
import React from 'react';
import { createPortal } from 'react-dom';
import { formatMessageDate } from '@/hooks/useDashboard';

export default function MessagePanel({
    isOpen,
    onClose,
    messages,
    onMarkAsRead,
    onMarkAllAsRead
}) {
    if (!isOpen) return null;

    return createPortal(
        <>
            <div id="message-panel" className="fixed inset-0 z-[100]">
                <div
                    className="absolute inset-0 bg-black/50 backdrop-blur-sm"
                    onClick={onClose}
                />
                <div className="absolute right-0 top-0 h-full w-full max-w-md bg-[#0f1219] border-l border-slate-700/50 shadow-2xl flex flex-col animate-slide-in-right">
                    {/* 패널 헤더 */}
                    <div className="flex items-center justify-between p-4 border-b border-slate-700/50">
                        <h3 className="font-bold text-white flex items-center gap-2">
                            <i className="fas fa-envelope text-cyan-400" />
                            관리자 메시지
                        </h3>
                        <div className="flex items-center gap-2">
                            <button
                                className="text-xs text-slate-400 hover:text-cyan-400 transition-colors"
                                onClick={onMarkAllAsRead}
                            >
                                모두 읽음
                            </button>
                            <button
                                className="p-2 text-slate-400 hover:text-white transition-colors"
                                onClick={onClose}
                            >
                                <i className="fas fa-times" />
                            </button>
                        </div>
                    </div>

                    {/* 메시지 목록 */}
                    <div className="flex-1 overflow-y-auto dashboard-scroll p-4 space-y-3">
                        {messages.length === 0 ? (
                            <div className="text-center py-12 text-slate-500">
                                <i className="fas fa-inbox text-4xl mb-3 opacity-50" />
                                <p className="text-sm">새로운 메시지가 없어요</p>
                            </div>
                        ) : (
                            messages.map((msg) => (
                                <div
                                    key={msg.id}
                                    className={`message-item ${msg.is_read ? 'opacity-70' : ''} bg-slate-800/50 rounded-lg p-4 cursor-pointer hover:bg-slate-700/50 transition-colors`}
                                    onClick={() => !msg.is_read && onMarkAsRead(msg.id)}
                                >
                                    <div className="flex items-start gap-3">
                                        <div className={`w-8 h-8 rounded-full ${msg.is_read ? 'bg-slate-600' : 'bg-cyan-500/20'} flex items-center justify-center flex-shrink-0`}>
                                            <i className={`fas fa-user-shield ${msg.is_read ? 'text-slate-400' : 'text-cyan-400'} text-sm`} />
                                        </div>
                                        <div className="flex-1 min-w-0">
                                            <div className="flex items-center gap-2 mb-1">
                                                <span className={`text-sm font-medium ${msg.is_read ? 'text-slate-400' : 'text-white'}`}>
                                                    {msg.sender || '관리자'}
                                                </span>
                                                {!msg.is_read && <span className="w-2 h-2 bg-cyan-400 rounded-full" />}
                                            </div>
                                            <p className={`text-sm ${msg.is_read ? 'text-slate-500' : 'text-slate-300'} leading-relaxed`}>
                                                {msg.message}
                                            </p>
                                            <div className="text-xs text-slate-600 mt-2">{formatMessageDate(msg.created_at)}</div>
                                        </div>
                                    </div>
                                </div>
                            ))
                        )}
                    </div>
                </div>
            </div>
            <style>{`
        .dashboard-scroll::-webkit-scrollbar {
          width: 6px;
        }
        .dashboard-scroll::-webkit-scrollbar-track {
          background: rgba(0, 0, 0, 0.2);
          border-radius: 3px;
        }
        .dashboard-scroll::-webkit-scrollbar-thumb {
          background: rgba(100, 116, 139, 0.5);
          border-radius: 3px;
        }
        .dashboard-scroll::-webkit-scrollbar-thumb:hover {
          background: rgba(100, 116, 139, 0.7);
        }
        @keyframes slide-in-right {
          from { transform: translateX(100%); }
          to { transform: translateX(0); }
        }
        .animate-slide-in-right {
          animation: slide-in-right 0.3s ease-out;
        }
      `}</style>
        </>
        , document.body);
}
